const T = {
  ko: {
    ranking:"랭킹", light:"라이트", dark:"다크", logout:"로그아웃",
    appTitle:"TripCanvas", appSub:"나만의 여행을 그리다",
    tagline:"당신만을 위한\n딱 맞는 여행 일정을\n짜드릴게요 ✈️",
    tagDesc:"혈액형 · MBTI · 별자리로 성향을 분석하고\n나만의 여행 코스와 맛집을 추천해드려요",
    signup:"📝 가입하기", login:"🔑 로그인",
    loginTitle:"로그인", loginDesc:"저장된 정보로 빠르게 시작하세요",
    emailLabel:"이메일", pwLabel:"비밀번호", loginBtn:"로그인 →",
    noAccount:"계정이 없으신가요?", goSignup:"가입하기 →", goBack:"← 돌아가기",
    personalTitle:"개인 정보 입력", signupTitle:"회원 가입",
    personalDesc:"성향 분석에 활용되는 나만의 여행 정보",
    signupDesc:"이메일과 비밀번호로 내 정보를 저장해요",
    emailIdNote:"이메일을 아이디로 사용함",
    nameLabel:"이름(닉네임)", ageLabel:"나이", genderLabel:"성별",
    addressLabel:"거주지 (시/구 단위)", bloodLabel:"혈액형", mbtiLabel:"MBTI", zodiacLabel:"별자리",
    male:"남성", female:"여성", selected:"✓ 선택됨",
    pwConfirmLabel:"비밀번호 확인",
    required:"필수", optional:"선택",
    privacyTitle:"개인정보 수집 및 이용 동의", privacyRequired:"(필수)",
    nextBtn:"다음 단계 →", signupBtn:"가입 완료 →", toMain:"🏠 메인페이지로",
    travelTitle:"여행 정보 입력", travelDesc:"떠나고 싶은 곳을 알려주세요",
    dateLabel:"여행 날짜", departureLabel:"출발지", destLabel:"목적지",
    departTimeLabel:"출발 시간", styleLabel:"여행 스타일", transportLabel:"이동 수단",
    useAddress:"거주지 사용", registeredAddr:"📍 등록된 거주지:",
    earlyMorn:"이른 아침", morn:"오전", afterNoon:"점심 후", eve:"오후",
    styles:["관광/문화 탐방형","맛집 투어 중심","자연/힐링형","쇼핑/트렌디형","역사/예술형","액티비티/모험형","휴양/여유형"],
    transports:[{value:"자가용",icon:"🚗",title:"자가용",desc:"자유로운 드라이브"},{value:"대중교통",icon:"🚇",title:"대중교통",desc:"버스·지하철·기차"}],
    prevBtn:"← 이전", generateBtn:"일정 생성 ✨",
    generatingTitle:"AI가 일정을 짜는 중...", generatingDesc:"잠시만 기다려주세요",
    itineraryTitle:"나만의 여행 일정 ✦", mapView:"지도 보기", listView:"목록 보기",
    editTitle:"일정 수정하기 💬", editPlaceholder:"일정 수정을 요청해보세요...", send:"전송",
    downloadPDF:"PDF 저장", writeReview:"✍️ 후기 쓰기", newTrip:"새 여행 계획",
    reviewTitle:"여행 후기", reviewDesc:"다른 여행자들과 경험을 나눠보세요",
    reviewers:"여행자들의 후기", noReviews:"아직 후기가 없어요",
    noReviewsDesc:"첫 번째 후기를 작성해 다른 여행자를 도와주세요!",
    ratingLabel:"별점", reviewTitleLabel:"후기 제목", reviewContentLabel:"후기 내용",
    submitReview:"후기 등록하기", helpful:"👍 도움이 됐어요",
    food:"음식", stay:"숙박", sight:"관광", move:"이동",
    steps:["정보","여행","일정","후기"],
    rankingTitle:"여행자 랭킹", rankingDesc:"가장 활발한 여행자들",
    myStats:"내 여행 기록",
    savedTrips:"보관함", community:"커뮤니티",
    savedTitle:"내 여행 보관함", savedDesc:"저장한 여행 일정들",
    noSaved:"저장된 일정이 없어요", noSavedDesc:"여행 일정을 생성하고 저장해보세요!",
    communityTitle:"여행 커뮤니티", communityDesc:"다른 여행자들의 일정을 구경해보세요",
    top5Title:"🔥 이번 주 인기 여행지 TOP 5",
    publicTrips:"공개된 여행 일정",
    noPublic:"공개된 일정이 없어요",
    shareTrip:"📤 공유하기", saveTrip:"💾 저장하기", savedOk:"✓ 저장됨",
    shareTitle:"일정 공유하기",
    shareLink:"링크 복사", shareCommunity:"커뮤니티 공유", shareCopied:"✓ 복사됨!",
    shareKakao:"카카오 공유",
    checklistTitle:"여행 준비 체크리스트", checklistDesc:"AI가 맞춤 체크리스트를 만들어드려요",
    checklistTab:"📋 체크리스트",
    packingTitle:"🧳 짐 챙기기", beforeTitle:"📝 여행 전 할 일", afterTitle:"🏠 여행 후 할 일",
    genChecklist:"AI 체크리스트 생성 ✨", genChecklistLoading:"체크리스트 생성 중...",
    checkAll:"전체 선택", resetChecklist:"초기화",
    progressLabel:"진행도",
  },
  en: {
    ranking:"Ranking", light:"Light", dark:"Dark", logout:"Logout",
    appTitle:"TripCanvas", appSub:"Paint Your Journey",
    tagline:"Your perfect trip,\npersonalized just for you ✈️",
    tagDesc:"We analyze your personality via MBTI, blood type & zodiac\nto recommend your ideal travel itinerary",
    signup:"📝 Sign Up", login:"🔑 Login",
    loginTitle:"Login", loginDesc:"Start quickly with your saved info",
    emailLabel:"Email", pwLabel:"Password", loginBtn:"Login →",
    noAccount:"Don't have an account?", goSignup:"Sign Up →", goBack:"← Back",
    personalTitle:"Personal Info", signupTitle:"Create Account",
    personalDesc:"Used to personalize your travel experience",
    signupDesc:"Save your profile with email & password",
    emailIdNote:"Your email is used as your ID",
    nameLabel:"Name (Nickname)", ageLabel:"Age", genderLabel:"Gender",
    addressLabel:"City / District", bloodLabel:"Blood Type", mbtiLabel:"MBTI", zodiacLabel:"Zodiac Sign",
    male:"Male", female:"Female", selected:"✓ Selected",
    pwConfirmLabel:"Confirm Password",
    required:"Required", optional:"Optional",
    privacyTitle:"Privacy Policy Agreement", privacyRequired:"(Required)",
    nextBtn:"Next →", signupBtn:"Complete Sign Up →", toMain:"🏠 Back to Home",
    travelTitle:"Trip Details", travelDesc:"Tell us where you want to go",
    dateLabel:"Travel Dates", departureLabel:"Departure", destLabel:"Destination",
    departTimeLabel:"Departure Time", styleLabel:"Travel Style", transportLabel:"Transport",
    useAddress:"Use my address", registeredAddr:"📍 Registered address:",
    earlyMorn:"Early Morning", morn:"Morning", afterNoon:"Afternoon", eve:"Evening",
    styles:["Sightseeing & Culture","Food Tour","Nature & Healing","Shopping & Trendy","History & Art","Adventure & Activities","Relaxation"],
    transports:[{value:"자가용",icon:"🚗",title:"Car",desc:"Free road trip"},{value:"대중교통",icon:"🚇",title:"Transit",desc:"Bus·Subway·Train"}],
    prevBtn:"← Back", generateBtn:"Generate Itinerary ✨",
    generatingTitle:"AI is planning your trip...", generatingDesc:"Please wait a moment",
    itineraryTitle:"Your Travel Itinerary ✦", mapView:"Map", listView:"List",
    editTitle:"Edit Itinerary 💬", editPlaceholder:"Ask to modify your itinerary...", send:"Send",
    downloadPDF:"Save PDF", writeReview:"✍️ Write Review", newTrip:"New Trip",
    reviewTitle:"Travel Reviews", reviewDesc:"Share your experience with other travelers",
    reviewers:"Traveler Reviews", noReviews:"No reviews yet",
    noReviewsDesc:"Be the first to help other travelers!",
    ratingLabel:"Rating", reviewTitleLabel:"Review Title", reviewContentLabel:"Review Content",
    submitReview:"Submit Review", helpful:"👍 Helpful",
    food:"Food", stay:"Stay", sight:"Sights", move:"Transit",
    steps:["Info","Trip","Plan","Review"],
    rankingTitle:"Traveler Rankings", rankingDesc:"Most active travelers",
    myStats:"My Travel Stats",
    savedTrips:"Saved", community:"Community",
    savedTitle:"My Saved Trips", savedDesc:"Your saved travel itineraries",
    noSaved:"No saved trips yet", noSavedDesc:"Generate a trip and save it!",
    communityTitle:"Travel Community", communityDesc:"Browse other travelers' itineraries",
    top5Title:"🔥 This Week's Top 5 Destinations",
    publicTrips:"Public Itineraries",
    noPublic:"No public itineraries yet",
    shareTrip:"📤 Share", saveTrip:"💾 Save", savedOk:"✓ Saved",
    shareTitle:"Share Itinerary",
    shareLink:"Copy Link", shareCommunity:"Share to Community", shareCopied:"✓ Copied!",
    shareKakao:"Kakao Share",
    checklistTitle:"Travel Checklist", checklistDesc:"AI-powered custom checklist",
    checklistTab:"📋 Checklist",
    packingTitle:"🧳 Packing List", beforeTitle:"📝 Before Trip", afterTitle:"🏠 After Trip",
    genChecklist:"Generate AI Checklist ✨", genChecklistLoading:"Generating...",
    checkAll:"Check All", resetChecklist:"Reset",
    progressLabel:"Progress",
  }
};

export default T;
